import { Button, Stack } from "@mui/material";
import { useRecoilState } from "recoil";
import ConfirmPopup from "src/shared/components/confirmation-popup";
import { useEffect, useState } from "react";
import { useValidateTicketMutation } from "src/api/tickets";
import { notificationsState } from "src/store/notifications";

const TableActions = ({
  rowId,
  ticketNumber,
  setForceRefetch,
}: {
  rowId: string;
  ticketNumber: string;
  setForceRefetch: Function;
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);

  const { mutate, isPending, status, error } = useValidateTicketMutation();

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };
  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleValidate = (note: string) => {
    mutate({
      ticketId: rowId,
      note: note,
    });
  };

  //Validate success and error handling
  useEffect(() => {
    if (status === "success") {
      setForceRefetch((prev: boolean) => !prev);
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: "The tickets is validated successfully",
        },
      ]);
      handleClosePopup();
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message:
            error?.data?.errors?.[0]?.message || "Oops! Something went wrong.",
        },
      ]);
    }
  }, [status]);

  return (
    <Stack direction={"row"}>
      <Button
        onClick={handleOpenPopup}
        color="secondary"
        variant="contained"
        sx={{ gap: "5px" }}
        size="small"
      >
        Validate
      </Button>

      <ConfirmPopup
        open={openPopup}
        setOpen={setOpenPopup}
        handleClose={handleClosePopup}
        subtitle={`Are you sure you want to validate the ticket number "${ticketNumber}" ?`}
        submitBtnLabel="Validate"
        onSave={handleValidate}
        isLoading={isPending}
        withNote
      />
    </Stack>
  );
};
export default TableActions;
